import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";

import Modal from "../../myfin_v2/elements/Modal";
import { Button } from "../../myfin_v2/elements/Button";

import commoncss from "../../myfin_v2/css/common.module.css";
import libcss from "../../myfin_v2/css/library.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import InputGroup from "../../myfin_v2/elements/InputGroup";

const AddSignature = ({ setShowAddSignatureModal, formData, setFormData }) => {
  const [selectedRole, setSelectedRole] = useState(null);
  useEffect(() => {
    console.log("selectedRole", selectedRole);
  }, [selectedRole]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = (formData) => {
    console.log("formData", formData);
  };

  return (
    <Modal
      width="50%"
      // minHeight="500px"
      title="Add Signature"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon onClick={() => setShowAddSignatureModal(false)} />
      }
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            label="Cancel"
            onClick={() => setShowAddSignatureModal(false)}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Add"
            onClick={() => {
              handleSave(formData);
            }}
          />
        </>
      }
    >
      <div style={{ padding: "10px 50px" }}>
        <div className={adminPortalCss.radioButtonSection}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="role"
            value={selectedRole}
            onChange={(e) => {setSelectedRole(e.target.value);handleChange("category", e.target.value)}}
            className={adminPortalCss.radioSection}
          >
            <FormControlLabel
              value="auditor"
              className={commoncss.radioDiv}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Auditor"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
            <FormControlLabel
              className={commoncss.radioDiv}
              value="board of director"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Board of Director"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
          </RadioGroup>
        </div>
        {selectedRole === "auditor" && (
          <div className={`my-3`}>
            <InputGroup
              label="Firm Name"
              inputs={[
                <>
                  <input
                    type="text"
                    value={formData.firmName || ""}
                    onChange={(e) => handleChange("firmName", e.target.value)}
                    placeholder="Enter Firm Name"
                  />
                </>,
              ]}
            />
            <div>
              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Role"
                      inputs={[
                        <input
                          type="text"
                          value={formData.firmRole || ""}
                          onChange={(e) =>
                            handleChange("firmRole", e.target.value)
                          }
                          placeholder="Enter Role"
                        />,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Firm Number"
                      inputs={[
                        <input
                          type="text"
                          value={formData.firmNumber || ""}
                          onChange={(e) =>
                            handleChange("firmNumber", e.target.value)
                          }
                          placeholder="Enter Firm Number"
                        />,
                      ]}
                    />
                  </>,
                ]}
              />
            </div>
            <InputGroup
              label="Auditor Name"
              inputs={[
                <>
                  <input
                    type="text"
                    value={formData.auditorName || ""}
                    onChange={(e) =>
                      handleChange("auditorName", e.target.value)
                    }
                    placeholder="Enter Auditor Name"
                  />
                </>,
              ]}
            />

            <div>
              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Auditor Role"
                      inputs={[
                        <input
                          type="text"
                          value={formData.auditorRole || ""}
                          onChange={(e) =>
                            handleChange("auditorRole", e.target.value)
                          }
                          placeholder="Enter Auditor Role"
                        />,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Membership Number"
                      inputs={[
                        <input
                          type="text"
                          value={formData.membershipNumber || ""}
                          onChange={(e) =>
                            handleChange("membershipNumber", e.target.value)
                          }
                          placeholder="Enter Membership Number"
                        />,
                      ]}
                    />
                  </>,
                ]}
              />
            </div>

            <div>
              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Place"
                      inputs={[
                        <input
                          type="text"
                          value={formData.place || ""}
                          onChange={(e) =>
                            handleChange("place", e.target.value)
                          }
                          placeholder="Enter Place"
                        />,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Date"
                      inputs={[
                        <input
                          type="text"
                          value={formData.date || ""}
                          onChange={(e) => handleChange("date", e.target.value)}
                          placeholder="Enter Date"
                        />,
                      ]}
                    />
                  </>,
                ]}
              />
            </div>
          </div>
        )}
        {selectedRole === "board_of_director" && (
          <div className={`${libcss.selectFsDiv} my-3`}></div>
        )}
      </div>
    </Modal>
  );
};

export default AddSignature;
